import http from '../utils/http';

// 登录用户
const userInfo = {
    /**
     * 权限-用户-获取个人信息
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#145
     * @returns Promise
     */
    base(){
        return http.post('/userinfo/basic')
    },
    /**
     * 权限-用户-修改密码
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#145
     * @returns Promise
     */
    changepwd(options={},config={}){
        return http.post('/userinfo/changepwd',options,{
            ...config
        })
    },
    /**
     * 权限-用户-修改基础信息
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#145
     * @returns Promise
     */
    modify(options={},config={}){
        return http.post('/userinfo/modify',options,{
            ...config
        })
    }
}

export default userInfo;
